<template>
  <div class="headPage">
    <div class="logo">
      海淀区科技类校外培训行业规范发展服务平台
    </div>
<!--    <div class="search">-->
<!--      <input type="text" placeholder="请输入搜索内容">-->
<!--      <i class="iconfont icon-sousuo"></i>-->
<!--    </div>-->
  </div>
</template>
<script>
export default {
  name: "headPage",
  data() {
    return {}
  },
  components: {},
  created() {

  },
  methods: {},
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.headPage {
  width: 100%;
  max-width: 1920px;
  padding-left: 205px;
  padding-right: 60px;
  margin: 0 auto;
  height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .logo {
    font-size: 38px;
    color: #ffffff;
    font-weight: bold;
  }
  .search {
    width: 375px;
    height: 52px;
    border-radius: 10px;
    border: solid 1px #c0d7e3;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    i {
      font-size: 20px;
      margin-left: 20px;
      color: #c0d7e3;
      cursor: pointer;
    }
    input {
      flex: 1;
      font-size: 14px;
      color: #c0d7e3;
      background: none;
      height: 50px;
    }
    input::placeholder {
      color: #c0d7e3;
    }
  }
}
</style>


